import { render, staticRenderFns } from "./Shelves.vue?vue&type=template&id=038ddc7b&scoped=true&"
import script from "./Shelves.vue?vue&type=script&lang=js&"
export * from "./Shelves.vue?vue&type=script&lang=js&"
import style0 from "./Shelves.vue?vue&type=style&index=0&id=038ddc7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038ddc7b",
  null
  
)

component.options.__file = "Shelves.vue"
export default component.exports